"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.normalizeQueryParams = exports.normalizeFiltersFromGraphQL = exports.isVehicleFilter = exports.hasErrors = exports.hasClearBtn = exports.getUpdatedSelectedFiltersState = exports.getUpdatedSelectedFiltersErrorsState = exports.getTotalSelectedFilters = exports.findSelectedValue = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _offersV = require("../offers-v3.config");
var _offersV2 = require("../offers-v3.utils");
var _filtersInputLabelKey, _filtersErrorMessages, _filtersOptionValueMa, _filtersOptionNameMap, _filtersOptionLabelKe, _filtersTitle;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var isVehicleFilter = exports.isVehicleFilter = function isVehicleFilter(key) {
  return key === _offersV.filtersMap.VEHICLE;
};
var filtersInputLabelKeyMap = (_filtersInputLabelKey = {}, _filtersInputLabelKey[_offersV.filtersMap.ZIP_CODE] = 'zipCodeLabel', _filtersInputLabelKey[_offersV.filtersMap.VEHICLE] = 'selectVehiclesLabel', _filtersInputLabelKey[_offersV.filtersMap.OFFER_TYPE] = 'offerTypeFilterLabel', _filtersInputLabelKey[_offersV.filtersMap.MODEL_YEAR] = 'modelYearLabel', _filtersInputLabelKey);
var filtersErrorMessagesKeyMap = (_filtersErrorMessages = {}, _filtersErrorMessages[_offersV.filtersMap.ZIP_CODE] = 'zipCodeErrorMsg', _filtersErrorMessages);
var filtersOptionValueMap = (_filtersOptionValueMa = {}, _filtersOptionValueMa[_offersV.filtersMap.VEHICLE] = 'code', _filtersOptionValueMa[_offersV.filtersMap.ZIP_CODE] = 'value', _filtersOptionValueMa);
var filtersOptionNameMap = (_filtersOptionNameMap = {}, _filtersOptionNameMap[_offersV.filtersMap.VEHICLE] = 'code', _filtersOptionNameMap[_offersV.filtersMap.ZIP_CODE] = 'value', _filtersOptionNameMap);
var filtersOptionLabelKeyMap = (_filtersOptionLabelKe = {}, _filtersOptionLabelKe[_offersV.filtersMap.VEHICLE] = 'vehicleName', _filtersOptionLabelKe[_offersV.filtersMap.ZIP_CODE] = 'title', _filtersOptionLabelKe);
var filtersTitle = (_filtersTitle = {}, _filtersTitle[_offersV.filtersMap.VEHICLE] = 'allVehiclesLabel', _filtersTitle);
var getTotalSelectedFilters = exports.getTotalSelectedFilters = function getTotalSelectedFilters(selectedFilters) {
  var totalReducer = function totalReducer(selected, value) {
    if (typeof value === 'string' && value) {
      return [].concat(selected, [true]);
    }
    return [].concat(selected, Object.values(value).filter(Boolean));
  };
  return Object.values(selectedFilters).reduce(totalReducer, []).length || null;
};
var getFilterMultipleValue = function getFilterMultipleValue(filter, filterKey) {
  var valuesReducer = function valuesReducer(valuesMap, currentFilter) {
    var key = currentFilter[filtersOptionNameMap[filterKey]] || 'id';
    if (key) {
      var _objectSpread2;
      return _objectSpread(_objectSpread({}, valuesMap), {}, (_objectSpread2 = {}, _objectSpread2[key] = false, _objectSpread2));
    }
    return valuesMap;
  };
  return filter.reduce(valuesReducer, {});
};
var getFilterValidationProps = function getFilterValidationProps(filter, filterKey, graphQLConfig) {
  try {
    var regEx = new RegExp(filter.validationRegEx);
    return {
      validate: function validate(value) {
        return regEx.test(value);
      },
      validationRegEx: regEx,
      errorMessage: graphQLConfig[filtersErrorMessagesKeyMap[filterKey]]
    };
  } catch (error) {
    // ignore
  }
  return {};
};
var normalizeQueryParams = exports.normalizeQueryParams = function normalizeQueryParams(queryParams) {
  return _offersV.filtersKeys.reduce(function (params, key) {
    var _objectSpread3;
    return _objectSpread(_objectSpread({}, params), {}, (_objectSpread3 = {}, _objectSpread3[key] = queryParams[key], _objectSpread3));
  }, {});
};
var normalizeFiltersFromGraphQL = exports.normalizeFiltersFromGraphQL = function normalizeFiltersFromGraphQL(graphQLConfig) {
  var parseFilter = function parseFilter(filter, filterKey) {
    var normalizedFilter = {
      key: filterKey,
      label: graphQLConfig[filtersInputLabelKeyMap[filterKey]] || 'Select',
      errorMessage: null,
      type: Array.isArray(filter) ? _offersV.filtersType.MULTIPLE : _offersV.filtersType.TEXT
    };
    if ((0, _offersV2.isFilterTypeMultiple)(normalizedFilter.type)) {
      normalizedFilter = _objectSpread(_objectSpread({}, normalizedFilter), {}, {
        defaultValue: getFilterMultipleValue(filter, filterKey),
        options: filter.map(function (option) {
          var optionValue = option[filtersOptionValueMap[filterKey]];
          var optionName = option[filtersOptionNameMap[filterKey]];
          return _objectSpread(_objectSpread({}, option), {}, {
            queryValue: Array.isArray(optionValue) ? optionValue.join(',') : optionValue,
            label: option[filtersOptionLabelKeyMap[filterKey]],
            name: optionName,
            value: optionName
          });
        })
      });
    }
    if ((0, _offersV2.isFilterTypeText)(normalizedFilter.type)) {
      normalizedFilter = _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, normalizedFilter), filter), getFilterValidationProps(filter, filterKey, graphQLConfig)), {}, {
        defaultValue: ''
      });
    }
    normalizedFilter.getPlaceholder = function (selectedFilters) {
      var labels = normalizedFilter.options.map(function (option) {
        return selectedFilters[normalizedFilter.key][option.name] && option.label;
      }).filter(Boolean);
      if (labels.length === 0 || labels.length === normalizedFilter.options.length) {
        return graphQLConfig[filtersTitle[normalizedFilter.key]];
      }
      return labels.join(', ');
    };
    return normalizedFilter;
  };
  var parsedFilters = _offersV.filtersKeys.map(function (filterKey) {
    return parseFilter(graphQLConfig[filterKey], filterKey);
  }).filter(Boolean);
  return parsedFilters;
};
var getUpdatedSelectedFiltersState = exports.getUpdatedSelectedFiltersState = function getUpdatedSelectedFiltersState(filter, target, selectedFilters, isSingleSelect) {
  var _objectSpread6;
  var isFilterMultiple = (0, _offersV2.isFilterTypeMultiple)(filter.type);
  var reset = {};
  if (isFilterMultiple && isSingleSelect) {
    for (var key in selectedFilters[filter.key] || {}) {
      if (Object.hasOwn(selectedFilters[filter.key], key)) {
        reset[key] = false;
      }
    }
  }
  var getValue = function getValue() {
    if (isFilterMultiple) {
      if (isSingleSelect) {
        var _objectSpread4;
        var _reset = {};
        for (var _key in selectedFilters[filter.key] || {}) {
          if (Object.hasOwn(selectedFilters[filter.key], _key)) {
            _reset[_key] = false;
          }
        }
        return _objectSpread(_objectSpread({}, _reset), {}, (_objectSpread4 = {}, _objectSpread4[target.name] = target.checked, _objectSpread4));
      } else {
        var _objectSpread5;
        return _objectSpread(_objectSpread({}, selectedFilters[filter.key]), {}, (_objectSpread5 = {}, _objectSpread5[target.name] = target.checked, _objectSpread5));
      }
    } else {
      return target.value;
    }
  };
  return _objectSpread(_objectSpread({}, selectedFilters), {}, (_objectSpread6 = {}, _objectSpread6[filter.key] = getValue(), _objectSpread6));
};
var getUpdatedSelectedFiltersErrorsState = exports.getUpdatedSelectedFiltersErrorsState = function getUpdatedSelectedFiltersErrorsState(filter, value, selectedFiltersErrors) {
  var _objectSpread8;
  if (!(0, _offersV2.isFilterTypeText)(filter.type) || typeof filter.validate !== 'function') {
    return selectedFiltersErrors;
  }

  // Reset error on empty input.
  // This wouldn't work with pristine/dirty states
  if (!value || filter.validate(value)) {
    var _objectSpread7;
    return _objectSpread(_objectSpread({}, selectedFiltersErrors), {}, (_objectSpread7 = {}, _objectSpread7[filter.key] = null, _objectSpread7));
  }
  return _objectSpread(_objectSpread({}, selectedFiltersErrors), {}, (_objectSpread8 = {}, _objectSpread8[filter.key] = filter.errorMessage, _objectSpread8));
};
var getSelectedFilterKeysMap = function getSelectedFilterKeysMap(selectedFilter) {
  if (!selectedFilter) {
    return {};
  }
  return Object.entries(selectedFilter).reduce(function (keysMap, _ref) {
    var _objectSpread9;
    var key = _ref[0],
      value = _ref[1];
    return value ? _objectSpread(_objectSpread({}, keysMap), {}, (_objectSpread9 = {}, _objectSpread9[key] = value, _objectSpread9)) : keysMap;
  }, {});
};
var hasClearBtn = exports.hasClearBtn = function hasClearBtn(selectedFilter) {
  return Object.values(getSelectedFilterKeysMap(selectedFilter)).length > 0;
};
var hasErrors = exports.hasErrors = function hasErrors(selectedFiltersErrors) {
  return Object.values(selectedFiltersErrors).filter(Boolean).length > 0;
};
var findSelectedValue = exports.findSelectedValue = function findSelectedValue(values) {
  var result;
  Object.keys(values).forEach(function (value) {
    if (values[value] === true) {
      result = value;
    }
  });
  return result;
};